import React from 'react';
import PropTypes from 'prop-types';

const SideBarReportsLogo = ({ bgColor = '#6D758E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0003 18.3334C5.39783 18.3334 1.66699 14.6026 1.66699 10.0001C1.66699 6.26841 4.11949 3.11008 7.50033 2.04841V3.81841C6.06776 4.40012 4.88182 5.4615 4.14537 6.82101C3.40893 8.18052 3.16773 9.75367 3.46304 11.2714C3.75835 12.7891 4.57182 14.157 5.7643 15.1412C6.95678 16.1254 8.45416 16.6646 10.0003 16.6667C11.3285 16.6667 12.6264 16.2701 13.7277 15.5278C14.829 14.7854 15.6836 13.7312 16.182 12.5001H17.952C16.8903 15.8809 13.732 18.3334 10.0003 18.3334ZM18.292 10.8334H9.16699V1.70841C9.44116 1.68091 9.71949 1.66675 10.0003 1.66675C14.6028 1.66675 18.3337 5.39758 18.3337 10.0001C18.3337 10.2809 18.3195 10.5592 18.292 10.8334ZM10.8337 3.38508V9.16675H16.6153C16.4298 7.69809 15.761 6.33286 14.7143 5.28611C13.6675 4.23936 12.3023 3.57057 10.8337 3.38508Z"
        fill={bgColor}
      />
    </svg>
  );
};

SideBarReportsLogo.propTypes = {
  bgColor: PropTypes.string,
};

export default SideBarReportsLogo;